import React,{ useLayoutEffect, useRef } from 'react'

import { gsap } from 'gsap';
import { useGSAP } from '@gsap/react';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger, useGSAP);

const Photocouple = ({ details }) => {

   const sectionRef = useRef(null)
  const topFrameRef = useRef(null)
  const bottomFrameRef = useRef(null)

 useGSAP(() => {
  const section = sectionRef.current;

  const frames = [
    topFrameRef.current,
    bottomFrameRef.current,
  ].filter(Boolean);

  // Safety check: handle missing elements gracefully
  if (!section || frames.length === 0) return;

  gsap.fromTo(
    frames,
    {
      autoAlpha: 0,
    },
    {
      autoAlpha: 1,
      duration: 1.2,
      stagger: 0.2,
      ease: 'power1.out',

      scrollTrigger: {
        trigger: section,
        start: 'top 75%',
        once: true,
      },
    }
  );
}, {
  scope: sectionRef,
});


    const renderPersonCard=({
    image,
    alt,
    fullname,
    parentprefix,
    parentsName,
    grandParentsPrefix,
    grandParentsName,
  })=>{
     if (!image?.url) return null;
     const baseUrl = image.url;

     return(
       <div className="t2-single-couple-container"  data-aos="fade-up">
        <div className="t2-couple-grandparents">
          <p>
             {grandParentsName && (
            <p>
              {grandParentsPrefix} {grandParentsName}
            </p>
          )}
          </p>
           </div>
               <img src={baseUrl} 
          alt={alt} 
          srcSet={`
         ${baseUrl.replace('/upload/', '/upload/w_320/')} 320w,
          ${baseUrl.replace('/upload/', '/upload/w_640/')} 640w,
           ${baseUrl.replace('/upload/', '/upload/w_1080/')} 1080w
         `}
           sizes="(max-width: 320px) 320px,
               (max-width: 640px) 640px,
               (max-width: 1080px) 1080px"
          className='t2-couple-image' />
         
         
          <h1 className='t2-couple-name'>{fullname}</h1>
            <div className="t2-couple-parents">
                          {parentsName && (
            <p>
              {parentprefix} {parentsName}
            </p>
          )}
                      </div>
      
       </div>
     )
  }


  const groomCard=()=>{
   return renderPersonCard({
     image:details?.groomImage,
      alt:"groomImage",
       fullname:details?.groomFullName || "Groom Full Name",
      parentprefix:details?.groomParentsPrefix,
      parentsName:details?.groomParents,
      grandParentsPrefix:details?.groomGrandParentsPrefix,
      grandParentsName:details?.groomGrandParents
    }
    )
  }

   const brideCard=()=>
    renderPersonCard({
      image:details?.brideImage,
      alt:"brideImage",
      fullname:details?.brideFullName || "Bride Full Name",
      parentprefix:details?.brideParentsPrefix,
      parentsName:details?.brideParents,
      grandParentsPrefix:details?.brideGrandParentsPrefix,
      grandParentsName:details?.brideGrandParents
    })




    return (
        <section className='couple-section photo-couple theme2' ref={sectionRef}>
            <img   ref={topFrameRef} src="/theme2coverAsset.png" className='t2-couple-frame-border t2-couple-frame-border-top ' alt="" />
            <img   ref={bottomFrameRef} src="/theme2coverAsset.png" className='t2-couple-frame-border  t2-couple-frame-border-bottom' alt="" />
            <div className="t2-couple-inner-container">
             <div className="t2-couple-inner-content">

               <h1 className='t2-couple-heading' data-aos="fade-up">{details?.sectionHeading}</h1>
            <div className="t2-couple-wrapper">
            {details?.displayOrder==="groomFirst"?<>
                    {groomCard()}
                     <span className="t2-couple-divider" data-aos="fade-up">
                        &
                    </span>
                    {brideCard()}

            </>:<>
                      {brideCard()}
                         <span className="t2-couple-divider" data-aos="fade-up">
                        &
                    </span>
                       {groomCard()}
            </>}
            </div>
             </div>
           
            </div>
        </section>
    )
}

export default Photocouple